import { render } from "./BackgroundPage.vue?vue&type=template&id=10e7141a&ts=true"
import script from "./BackgroundPage.vue?vue&type=script&lang=ts"
export * from "./BackgroundPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__